export default [
    //需求管理
    {
        path: '/xuqiu/Lmanagement',
        component: () => import( '@/views/loud/xuqiu/Lmanagement.vue'),
        meta: {
            title: '需求列表',
            isTabsPage: true,
            keepAlive:true
        }
    },
	//需求管理
	{
	    path: '/xuqiu/demandManagement',
	    component: () => import( '@/views/loud/xuqiu/demandManagement.vue'),
	},
    // 需求详情
    {
        path: '/xuqiu/xuqiuDetail',
        component: () => import( '@/views/loud/xuqiu/xuqiuDetail.vue'),
    },
    // 需求详情
    {
        path: '/xuqiu/xuqiuDetailReadonly',
        component: () => import( '@/views/loud/xuqiu/xuqiuDetailReadonly.vue'),
    },
    // 新建资源需求
    {
        path: '/xuqiu/createResources',
        component: () => import( '@/views/loud/xuqiu/createResources.vue'),
    },
    // 新建订单需求
    {
        path: '/xuqiu/createOrder',
        component: () => import( '@/views/loud/xuqiu/createOrder.vue'),
    },
    {
        path: '/xuqiu/purchase',
        component: () => import( '@/views/loud/xuqiu/purchase.vue'),
        meta: {
            title: '采购需求',
            requireAuth: true
        }
    },
    {
        path: '/xuqiu/purchasesh',
        component: () => import( '@/views/loud/xuqiu/purchasesh.vue'),
        meta: {
            title: '采购需求',
            requireAuth: true
        }
    },
    {
        path: '/xuqiu/purchaseDetail',
        component: () => import( '@/views/loud/xuqiu/purchaseDetail.vue'),
        meta: {
            title: '采购详情',
            requireAuth: true
        }
    },
    {
        path: '/xuqiu/resources',
        component: () => import( '@/views/loud/xuqiu/resources.vue'),
        meta: {
            title: '资源需求闭环',
            requireAuth: true
        }
    },
	{
		//新建需求弹窗
		path: '/xuqiu/createXuqiu',
		component: () => import( '@/views/loud/xuqiu/createXuqiu.vue'),
        meta: {
            title: '新建需求',
            isTabsPage: true,
            keepAlive:true
        }
	},
    {
        //资源需求列表
        path: '/xuqiu/resourceList',
        component: () => import( '@/views/loud/xuqiu/resourceList.vue'),
        meta: {keepAlive:true,title: '资源需求',
            isTabsPage: true
        }
    },
    {
        //资源需求列表
        path: '/xuqiu/jobUser',
        component: () => import( '@/views/loud/xuqiu/jobUser.vue'),
        meta: {
            title: '链群人员',
            isTabsPage: true,
            keepAlive:true
        }
    },
	{
	    //1+N体系列表
	    path: '/xuqiu/resourceEva',
	    component: () => import( '@/views/loud/xuqiu/resourceEva.vue'),
	},
    /*{
        //1+N体系列表
        path: '/xuqiu/createResEva',
        component: () => import( '@/views/loud/xuqiu/createResEva.vue'),
    },
	{
	    //1+N体系详情
	    path: '/xuqiu/resourceEvaDetail',
	    component: () => import( '@/views/loud/xuqiu/resourceEvaDetail.vue'),
	}*/
]
